// removed by extract-text-webpack-plugin
module.exports = {"item":"_3h0Q"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/PickANumber/PickANumber.scss
// module id = KkU3
// module chunks = 0